// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__iMr2i","light":"Nav_light__JpHm3","logo":"Nav_logo__CGlwg","logoName":"Nav_logoName__DKLi8","links":"Nav_links__MwC2F","active":"Nav_active__IBB1P"};